import axios from 'axios';
import { captureErrorOnce } from 'lib/sentry/captureError';
import Cookies from 'js-cookie';
import { GET_IN_AUTH_TOKEN_COOKIE_KEY } from 'utils/constants';
import ICustomAxiosRequestConfig from './custom/ICustomAxiosRequestConfig';

export const BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL || 'https://user-test.getinapis.com';

export const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(async (config: ICustomAxiosRequestConfig) => {
  const token =
    Cookies.get(GET_IN_AUTH_TOKEN_COOKIE_KEY) === 'undefined'
      ? ''
      : Cookies.get(GET_IN_AUTH_TOKEN_COOKIE_KEY);

  if (config.headers && token) {
    config.headers.authorization = `Bearer ${token}`;
  }

  if (config.headers && config.serverSide) {
    config.headers['GI-BYPS-RL'] = `${process.env.NEXT_PUBLIC_HEADER_KEY}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    const status = error.response?.status;
    const shouldReport = !status || status >= 500;

    if (shouldReport) {
      captureErrorOnce(error, {
        tags: {
          source: 'api',
          type: status ? 'http_5xx' : 'network',
          axios_code: error.code,
        },
        extra: {
          url: error.config?.url,
          method: error.config?.method,
          status,
        },
      });
    }

    return Promise.reject(error);
  }
);
